import styled, { x } from '@xstyled/styled-components';
import React, { Ref } from 'react';
import DownloadIcon from '~/assets/icons/download-policy.svg';
import { select } from '~/lib/select';
import { Flex } from '~/ui/flex/Flex';
import { TrainingState, useTrainingStore } from '../state';
import { t } from 'ttag';

export const DOCUMENTS_DIALOG_TITLE_ID = 'documents-dialog-title';

const List = styled.ulBox`
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 350px;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 8px;
  box-sizing: border-box;

  @media (max-height: 550px) {
    max-height: 150px;
  }
`;

const Title = styled.h4`
  text-align: center;
  outline: none;
  font-size: lg;

  @media (min-width: sm) {
    font-size: xl;
  }
`;

const ListItem = styled.a`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  max-width: 280px;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 4px 8px 4px 12px;
  background-color: transparent;
  border: 2px solid transparent;
  border-bottom: 2px solid ${({ theme }) => theme.colors.greyLight};

  p {
    max-width: 220px;
    padding-left: 4px;
  }

  &:hover {
    border-bottom: 2px solid ${({ theme }) => theme.colors.accentDark};
  }

  &:focus {
    outline: 2px solid var(--color-focus-ring);
    outline-offset: 2px;
    border-color: transparent;
    z-index: 1;
  }

  &:focus::after {
    content: '';
    display: block;
    position: absolute;
    border-radius: 0;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border: 2px solid white;
    pointer-events: none;
  }
`;

const selector = (s: TrainingState) => select(s, 'policies');

export const Root = ({ titleRef }: { titleRef: Ref<HTMLHeadingElement> }) => {
  const { policies } = useTrainingStore(selector);

  return (
    <Flex w={{ _: '80vw', sm: 'auto' }} gap="30px" variant="list">
      <Title
        ref={titleRef}
        id={DOCUMENTS_DIALOG_TITLE_ID}
        tabIndex={-1}
      >{t`Documents`}</Title>
      <List>
        {policies?.map(policy => (
          <li key={policy.id}>
            <ListItem
              target="_blank"
              href={policy.policyUrl || '#'}
              rel="noopener noreferrer"
              onClick={event => {
                if (!policy.policyUrl) {
                  event.preventDefault();
                }
              }}
            >
              <x.p textAlign="left">{policy.name}</x.p>
              <x.div aria-hidden="true">
                <DownloadIcon />
              </x.div>
            </ListItem>
          </li>
        ))}
      </List>
    </Flex>
  );
};
